import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery } from 'gatsby'
import { graphql } from 'gatsby'

import SixtineCSS from './section-sixtine.module.css'

const FingerSixtine = ({ fullpageApi }) => (
  <StaticQuery
    query={graphql`
      query ImageOneSixtine {
        file(
          relativePath: { eq: "projets/Labo/finger/photos/finger-sixtine.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 87) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={({ file }) => (
      <div
        className="section"
        onClick={() => fullpageApi.moveSectionDown()}
        onKeyDown={() => fullpageApi.moveSectionDown()}
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer' }}
      >
        <Img
          className={SixtineCSS.image}
          imgStyle={{ objectPosition: 'center center', objectFit: 'contain' }}
          fluid={file.childImageSharp.fluid}
        />
      </div>
    )}
  />
)

export default FingerSixtine
